<template>
	<div id="app">
        <cookies-banner></cookies-banner>
		<div class="container" :class="{mobile: $root.isMobile, desktop: !$root.isMobile}" >
            <a v-if="screen !== 5" href="https://www.seek.com.au" target="_blank" class="seek-link">
                <div v-if="$root.isMobile" class="seek-logo"><img src="/images/seek_logo.png"/></div>
            </a>
            <button v-if="screen > 1" @click="changeScreen(screen, -1)" class="arrow-left">
                <div class="splash-dot-left"></div>
                <div class="splash-dot-left"></div>
                <div class="splash-dot-left"></div>
                <div class="splash-dot-left"></div>
                <div class="splash-dot-left"></div>
                <div class="splash-dot-left"></div>
                <div class="splash-dot-left"></div>
                <div class="splash-dot-left"></div>
                <img src="/images/arrow-circle-left.svg" alt="arrow" />
            </button>
            <button :style="buttonStyle" v-if="screen > 1 && screen !== 6" @click="changeScreen(screen, 1)" class="arrow-right">
                <div class="splash-dot-right"></div>
                <div class="splash-dot-right"></div>
                <div class="splash-dot-right"></div>
                <div class="splash-dot-right"></div>
                <div class="splash-dot-right"></div>
                <div class="splash-dot-right"></div>
                <div class="splash-dot-right"></div>
                <div class="splash-dot-right"></div>
                <img :class="{'button-glow': rightArrow}" src="/images/arrow-circle-right.svg" alt="arrow" />
            </button>
            <img v-if="screen !== 5" class="listen-on-spotify" src="/images/listen-on-spotify-white.svg" alt="Listen on Spotify" />
			<transition name="fade" mode="out-in">
				<router-view @allowForwards="allowRightArrow" :arrowButtonAction="buttonEffect" />
			</transition>
		</div>
        <a v-if="screen !== 5" href="https:www.seek.com.au" target="_blank">
            <img v-if="!$root.isMobile" class="desktop-seek" src="/images/seekwhite.png" alt="Seek logo"/>
        </a>
        <spotify-footer v-if="screen !== 5"></spotify-footer>
	</div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';
export default {
    data() {
        return {
            rightArrow: false,
            buttonStyle: {
                opacity: 1
            },
            buttonEffect: false,

        }
    },
    mounted () {
        const videos = this.$root.isMobile ? [
            '/videos/mobile_homeScreen.mp4',
            '/videos/mobile_spaghetti.mp4',
            '/videos/mobile_stars.mp4',
        ]
        : [
            '/videos/desktop_homeScreen.mp4',
            '/videos/desktop_spaghetti.mp4',
            '/videos/desktop_stars.mp4',
        ]

        const images = [
            '/images/walter.png',
            '/images/wheel.png',
            '/images/reshaping.jpg',
            '/images/save.png',
            '/images/continue.png',
            '/images/share.png',
        ]

        const loadVideos = async () => {            
            for (let i = 0; i < videos.length; i++) {
                const video = await createVideo(i);
            } 
        }
        const loadImages = async () => {            
            for (let i = 0; i < images.length; i++) {
                const video = await createImage(i);
            } 
        }

        const createVideo = (i) => {
            let video = document.createElement('video');
            video.src = videos[i];
            return video;
        }
        const createImage = (i) => {
            let image = document.createElement('img');
            image.src = images[i];
            return image;
        }

        loadVideos();
        loadImages();
        
    },
    computed: {
        screen: function() {
            let step = parseInt(this.$route.name);
            if (!this.rightArrow) {
                this.buttonStyle.opacity = 0.3;
            }
            else {
                this.buttonStyle.opacity = 1;
            }

            if (!screen) return 1;
            return step;
        }
    },
    methods: {
        allowRightArrow(val) {
            this.rightArrow = val;
        },
        changeScreen(screen, direction) {
            if (direction < 0 && screen === 1) return;
            if (direction > 0 && !this.rightArrow) return;
            setTimeout(() => {
                this.rightArrow = false;
                if (localStorage.getItem('spotifyAuthCode')) {
                    if (screen === 5 && direction < 0) direction += direction;
                    if (screen === 3 && direction > 0) direction += direction;
                } 
                this.buttonEffect = false;
                const pages = [
                    'Landing Page',
                    'Walter Name Page',
                    'What Keeps You Up Quiz',
                    'Genres Page',
                    'Bedtime Rhyme',
                    'Results Page',
                ]
                if (direction > 0) this.gaEvent(pages[screen - 1], 'Clicked continue to next page')
                
                this.$router.push({name: parseInt(screen) + direction});
            }, 550)

            const nodes = direction < 0 
                ? document.querySelectorAll('.splash-dot-left') 
                : document.querySelectorAll('.splash-dot-right');
            
            const transformProps = [
                {
                    x: ['0px', '50px'],
                    y: ['0px', '50px']
                },
                {
                    x: ['0px', '-50px'],
                    y: ['0px', '-50px']
                },
                {
                    x: ['0px', '75px'],
                    y: ['0px', '0px']
                },
                {
                    x: ['0px', '0px'],
                    y: ['0px', '75px']
                },
                {
                    x: ['0px', '-75px'],
                    y: ['0px', '0px']
                },
                {
                    x: ['0px', '0px'],
                    y: ['0px', '-75px']
                },
                {
                    x: ['0px', '-50px'],
                    y: ['0px', '50px']
                },
                {
                    x: ['0px', '50px'],
                    y: ['0px', '-50px']
                },
            ]
            for (let i = 0; i < nodes.length; i ++) {
                anime({
                    targets: nodes[i],
                    translateX: transformProps[i].x,
                    translateY: transformProps[i].y,
                    width: ['0px', '10px', '5px', '2px', '0px'],
                    height: ['0px', '10px', '5px', '2px', '0px'],
                    easing: 'linear',
                    opacity: [1, 1],
                    duration: 500,
                    delay: 50
                });
            }
            anime({
                targets: 'button img',
                translateX: [0,2,0],
                translateY: [0,2,0],
                easing: 'linear',
                duration: 100,
            });
        }
    }
};
</script>

<style scoped>
#app {
    background: #024996;
    overflow: hidden;
    position: relative;
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 1s;
}
.fade-enter, .fade-leave {
	opacity: 0;
}
/* .fadeIn-enter-to {
	opacity: 1;
} */

.container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
}

.listen-on-spotify {
    width: 15rem;
    position: absolute;
    top: 1rem;
    z-index: 100;
}

.desktop .listen-on-spotify {
    top: unset;
    bottom: 0;
    margin-bottom: 1rem;
    width: 10rem;
    right: 0;
    margin-right: 1rem;
}

button {
    position: absolute;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.splash-dot-left, .splash-dot-right {
    background: white;
    border-radius: 50px;
    position: absolute;
    opacity: 0;
}

.arrow-left {
    left: 1.5rem;
}

.arrow-right {
    right: 1.5rem;
}

button img {
    width: 3rem;
    filter: invert(1);
    border-radius: 50%;
    box-shadow: 2px 2px 6px -1px #4e4e4e;
}

.button-glow {
    animation: glow 2s infinite;
}

@keyframes glow {
    0% {transform: translateY(0px)}
    10% {transform: translateY(-10px)}
    20% {transform: translateY(0px)}
    25% {transform: translateY(-4px)}
    30% {transform: translateY(0px)}
}

.seek-logo {
    padding: 0.5rem;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.seek-logo img {
	width: 6rem;
}

.desktop-seek {
    width: 5rem;
    position: absolute;
    left: 0;
    bottom: 0;
    margin-bottom: 0.6rem;
    margin-left: 1rem;
    z-index: 1;
}

.seek-link {
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 3rem;
    z-index: 100;
}
</style>

<style>
.button-bounce {
	animation: pressbounce 0.5s;
}
@keyframes pressbounce {
	0% {transform: scale(1.02)}
	25% {transform: scale(0.9)}
	50% {transform: scale(1.03)}
	75% {transform: scale(0.98)}
	100% {transform: scale(1)}
}

.button-pulse {
	animation: buttonpulse 7s 7s infinite;
}
@keyframes buttonpulse {
	0% {transform: scale(1);}
	3% {transform: scale(1.03);}
    6% {transform: scale(1);}
	9% {transform: scale(1.03);}
	12% {transform: scale(1);}
	100% {transform: scale(1);}
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

@keyframes bounce-in {
    0% {
        opacity: 0;
		transform: scale(.8);
    }
    40% {
        opacity: 1;
        transform: scale(1.02)
    }
    70% {
        transform: scale(.9)
    }
    100% {
        transform: scale(1)
    }
}

h1 {
    font-family: 'Seek Regular';
    text-align: center;
    padding: 0 3rem;
    font-size: 4.8rem;
    line-height: 0.8;
}

.mobile h1 {
    font-size: 3rem;
}

h1 span {
    font-family: 'Seek Regular';
}

.video-container {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%; 
    overflow: hidden;
}

video, iframe {
    min-width: 100%;
    min-height: 100%;

    /* Setting width & height to auto prevents the browser from stretching or squishing the video */
    width: auto;
    height: auto;

    /* Center the video */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

.mobile video, .mobile iframe {
    height: 100%;
    min-width: 100%;
    min-height: 110%;
}

.page {
	overflow: hidden;
	height: 100vh;
	width: 100%;
}

.page-inner {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: space-between;
    padding: 5rem 0;
    z-index: 1;
}

.desktop .page-inner {
    justify-content: center;
}

h2 {
    padding: 0 2rem;
    text-align: center;
    text-transform: uppercase;
}

button:focus, button:active {
    outline: none;
}

.desktop h1, .desktop h2 {
    position: absolute;
    top: 0;
    margin-top: 5rem;
}

.desktop h2 {
    width: 30rem;
}

.button-title {
    width: 18rem;
    text-align: center;
    line-height: 1;
    text-transform: uppercase;
    font-size: 2.5rem;
    margin: auto;
    font-family: 'Seek Regular';
    line-height: 0.8;
}

button:hover {
    transform: scale(1.03);
}
</style>